export const lightGrey = `#f3f4f6`
export const offWhite = `#ffffff`
export const darkGrey = "#262626"
export const logoOrange = "#d97706"
export const logoOrangeLighten = "#fef3c7"
export const logoRed = "#dc2626"
export const logoRedLighten = "#fee2e2"
